const noindexPages = [
  '/payment/fail/',
  '/payment/success/',
  '/bill/success/',
  '/bill/',
  '/bill/fail/',
  '/general/',
  '/user-registration/',
  '/signup/'
]

export const isNoindexNofollow = (url) => {
  return (process.env.NODE_ENV === 'development' || noindexPages.includes(url));
}
